import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import Dialog from '..'
import { PinInput } from '../..'
import PinOptions from '../../PinOptions'
import { GuidanceIcon } from '../../icons'
import styles from './styles'
import decodeBase64 from '../../../utils/decodeBase64'
import { clearPinAccepted } from '../../../actions'

const PinCheckDialog = (props) => {
  const [incorrectPinEntered, setIncorrectPinEntered] = useState(false)
  const encodedPin = useSelector(state => state.pinAcceptance.encodedPin)
  const dispatch = useDispatch()

  const handlePinEntered = (pin) => {
    const decodedPin = decodeBase64(encodedPin)

    if (pin === decodedPin) {
      props.setPinAccepted()
    } else {
      clearPin()
    }
  }

  const clearPin = () => {
    setIncorrectPinEntered(true)
    dispatch(clearPinAccepted(true))
  }

  return (
    <div className="PinCheckDialog">
      <Dialog
        title={(
          <Fragment>
            <GuidanceIcon />
            This episode contains a guidance warning
          </Fragment>
        )}
        subtitle={`${props.guidanceText}`}
        supplementaryText="Please enter your PIN."
      />

      <form>
        <PinInput
          handleChange={handlePinEntered}
        />
      </form>

      {incorrectPinEntered && (
        <p className="incorrect-pin-warning">
          PIN incorrect, please try again.
        </p>
      )}

      <PinOptions />

      <style jsx>{ styles }</style>
    </div>
  )
}

PinCheckDialog.propTypes = {
  guidanceText: PropTypes.string.isRequired,
  setPinAccepted: PropTypes.func.isRequired,
}

export default PinCheckDialog
